import React, { useEffect } from "react";
import { useTranslation } from "i18n";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_PATH, CheckoutType } from "config/common";
import { Head, useGetSubscriptionActions } from "component-library";
import { useCanAccessCheckout } from "component-library/src/components/Organisms/Billing/hooks/useCanAccessCheckout";
import { USER_ACCOUNT_APP_ROOT } from "component-library/src/components/Organisms/Billing/constants";
import CheckoutPageWrapper from "../CheckoutPageWrapper/CheckoutPageWrapper";
import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";
import { checkSubscriptionActionHasPermit } from "helpers/checkSubscriptionActionHasPermit";
import { isAcceptedCheckoutType } from "../CheckoutPageWrapper/helpers/helpers";

const Checkout = () => {
  const { type } = useParams<{ type: string }>();
  const isSelfServeCancellationEnable = useLaunchDarklyFlags(
    FEATURE_FLAGS.SelfServeCancellation
  );
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: subscriptionActions } = useGetSubscriptionActions(
    isSelfServeCancellationEnable
  );

  useEffect(() => {
    if (
      subscriptionActions &&
      !checkSubscriptionActionHasPermit(
        subscriptionActions,
        type as CheckoutType
      )
    ) {
      window.location.replace(USER_ACCOUNT_APP_ROOT);
    }
  }, [type, subscriptionActions]);

  useEffect(() => {
    if (!isAcceptedCheckoutType(type)) {
      return navigate(BASE_PATH, { replace: true });
    }
  }, [type]);

  useCanAccessCheckout(true, USER_ACCOUNT_APP_ROOT);

  return (
    <>
      <Head>
        <title>{t("common:billing.checkout.pageTitle")}</title>
      </Head>
      <CheckoutPageWrapper />
    </>
  );
};

export default Checkout;
